export const blogsData = [
    {
        id: 0,
        title: "Data types in Javascript",
        description: `JavaScript is dynamic typed languages. It means we don't have to define a definite data type for a variable ...`,
        image: './image/blog/blog-1.png',
        link: 'https://foysal-dev.medium.com/data-types-in-javascript-bdec2df42e90',
    },
    {
        id: 2,
        title: "10 Core concepts in React JS",
        description: `React JS is one of the most popular javascript library for creating UI ...`,
        image: './image/blog/blog-2.png',
        link: 'https://foysal-dev.medium.com/10-core-concepts-in-react-js-f6e0a93e785b',
    },
    {
        id: 2,
        title: "Basic coding problems with solution in Javascript",
        description: `In this blog post I have discussed most famous interview question for front end developer ...`,
        image: './image/blog/blog-3.png',
        link: 'https://foysal-dev.medium.com/basic-coding-problems-with-solution-in-java-64018145a6b1',
    },
]